module.exports = __webpack_public_path__ + "media/images/result_sets/circles/3n4r6r9r-97acee9a65237f88819850809f6b9a63.svg";